module.exports = __webpack_public_path__ + "img/2.000a14fc.png";